export enum WidgetViews {
    PROCESSING = 'processing',
    LOADING = 'loading',
    ERROR = 'error',
    CLOSE_WIDGET = 'close-widget',
    CUSTOM_PAGE_PREVIEW = 'custom-page-preview'
}

export type WidgetApps =
    | 'comply-cube-document-check'
    | 'comply-cube-video-verification'
    | 'custom-page'
    | 'edo-app'
    | 'p24-verification-payment'
    | 'autopay-verification-payment'
    | 'transactionlink-open-banking'
    | 'transactionlink-sms-verification'
    | 'twilio'
    | 'veriff-document-check'
    | 'veriff-video-verification'
    | 'veriff-age-estimation'
    | 'yapily'
    | 'zoho-sign'
    | 'ondato-vv'
    | 'workflow-finish'
    | 'idenfy-video-verification'
    | 'moje-id-verification'
    | 'gbg-id-verification'
    | 'mobywatel-id-verification'
    | 'smart-id-verification'
    | 'bank-id-norway-verification'
    | 'bank-id-denmark-verification'
    | 'bank-id-czechia-verification'
    | 'comply-cube-face-authentication'
    | 'au10tix-video-verification'
